export const HOME_PAGE_PATH = '/';
export const LOGIN_PAGE_PATH = '/login';
export const INVOICING_PAGE_PATH = '/invoicing';
export const ACCOUNTING_PAGE_PATH = '/accounting';
export const UPDATE_INVOICE_PAGE_PATH = '/invoicing/';
export const UPDATE_INVOICE_PAGE_FULL_PATH = '/invoicing/:id';
export const SALES_PAGE_PATH = '/sales';
export const PURCHASES_PAGE_PATH = '/purchases';
export const MATCHING_INVOICE_PAGE_PATH = '/matching_invoice/';
export const MATCHING_INVOICE_PAGE_FULL_PATH = '/matching_invoice/:id';
export const BANKS_PAGE_PATH = '/banks';
export const ADD_BANK_PAGE_PATH = '/banks/add_bank';
export const BANK_DETAILS_PAGE_PATH = '/banks/';
export const BANK_DETAILS_PAGE_FULL_PATH = '/banks/:id';
export const CUSTOMERS_PAGE_PATH = '/customers';
export const CUSTOMER_DETAILS_PAGE_PATH = '/customers/';
export const CUSTOMER_DETAILS_PAGE_FULL_PATH = '/customers/:id';
export const EMPLOYEES_PAGE_PATH = '/employees';
export const CONTRACTORS_PAGE = '/contractors';
export const PURCHASES_PAGE = '/purchases';
export const SALES_PAGE = '/sales';
export const CONTRACTORS_PAGE_PATH = '/contractors';
export const TRAVELS_PAGE_PATH = '/travels';
export const BUSINESS_INFO_PAGE_PATH = '/business_info';
export const EDIT_COMPANY_MEMBER_DETAILS_PAGE_PATH = '/business_info/members/';
export const EDIT_COMPANY_MEMBER_DETAILS_PAGE_FULL_PATH = '/business_info/members/:id';
export const ACCOUNTING_REPORTS_PAGE_PATH = '/accounting_reports';
export const ANNUAL_REPORT_PAGE_PATH = '/annual_report';
export const TICKETS_PAGE_PATH = '/tickets';
export const TRANSACTION_HISTORY_PATH = '/transaction_history';
export const SETTINGS_PAGE_PATH = '/settings';
export const PROFILE_SETTINGS_PAGE_PATH = '/settings/profile';
export const REFERRAL_SETTINGS_PAGE_PATH = '/settings/referral';
export const REFERRAL_HISTORY_PAGE_PATH = '/settings/referral/history';
export const TEAM_SETTINGS_PAGE_PATH = '/settings/team';
export const TEAM_MEMBER_SETTINGS_PAGE_FULL_PATH = '/settings/team/user/:id';
export const TEAM_MEMBER_SETTINGS_PAGE_PATH = '/settings/team/user/';
export const BILLING_SETTINGS_PAGE_PATH = '/settings/billing';
export const ADD_CARD_PAGE_PATH = '/settings/billing/add_card';
export const AUTOMATION_SETTINGS_PAGE_PATH = '/settings/automation';
export const OTHER_SETTINGS_PAGE_PATH = '/settings/others';
export const SUBSCRIPTION_SETTINGS_PAGE_PATH = '/settings/subscription';
export const SUBSCRIPTION_CHANGE_PLAN_PAGE_PATH = '/change/plan';
export const SUBSCRIPTION_CHANGE_PLAN_PAGE_FULL_PATH = '/change/plan/:option';
export const ANNUAL_REPORT_DETAILS_PAGE_PATH = '/annual_report/:id';
export const ANNUAL_REPORT_DETAILS_CONNECTED_BANKS_PAGE_PATH =
  '/annual_report/:id/check_connected_banks';
export const ANNUAL_REPORT_DETAILS_MISSING_BANK_STATEMENTS_PAGE_PATH =
  '/annual_report/:id/missing_bank_statements';
export const ANNUAL_REPORT_DETAILS_DOCUMENTS_FOR_TRANSACTIONS_PAGE_PATH =
  '/annual_report/:id/missing_documents_for_transactions';
export const ANNUAL_REPORT_DETAILS_PAYMENTS_FOR_DOCUMENTS_PAGE_PATH =
  '/annual_report/:id/missing_payments_for_documents';
export const ANNUAL_REPORT_DETAILS_OTHER_DOCUMENTS_PAGE_PATH = '/annual_report/:id/other_documents';
export const ADD_CONTRACTOR_PAGE_PATH = '/contractors/add_contractor';
export const CONTRACTORS_DETAILS_PAGE_PATH = '/contractors/:id';
export const CONTRACTORS_EDIT_PAGE_PATH = '/contractors/edit';
export const CONTRACTORS_EDIT_PAGE_PATH_ID = '/contractors/edit/:id';
export const ADD_BUSISNESS_TRAVEL_PAGE_PATH = '/travels/add_travel';
export const SEE_TRAVEL_DETAILS_PATH = '/travels/see_details/';
export const SEE_TRAVEL_DETAILS_PAGE_FULL_PATH = '/travels/see_details/:id';
export const TRAVEL_DOCUMENTS_PATH = '/travels/documents';
export const ADD_EMPLOYEE_PAGE_PATH = '/employees/add_employee';
export const EMPLOYEES_DETAILS_PAGE_PATH = '/employees/:id';
export const EMPLOYEE_DETAILS_PAGE_QUOTE_PATH = '/employee_quote_review/:id';
export const EMPLOYEE_QUOTE_PATH = '/employee_quote_review';
export const EMPLOYEES_EDIT_PAGE_PATH_ID = '/employees/edit/:id';
export const EMPLOYEES_EDIT_PAGE_PATH = '/employees/edit';
export const COMMUNICATION_CENTER_PAGE_PATH = '/notifications';
export const SUPPORT_PAGE_PATH = '/support';
export const SUPPORT_TICKET_PAGE_PATH = '/support/ticket';
export const SUPPORT_TICKET_PAGE_FULL_PATH = '/support/ticket/:id';
export const MATCH_NET_SETTLEMENTS_PAGE = '/match_net_settlements/';
export const BANK_STATEMENTS_PAGE_PATH = '/bank_statements';
export const MATCHING_DOCUMENT_PAGE_PATH = '/matching_document';
export const MATCHING_DOCUMENT_PAGE_FULL_PATH = '/matching_document/:id';
export const MATCH_TRANSACTION_PAGE_PATH = '/match_transaction';
export const MATCH_INTERNAL_TRANSACTIONS_PAGE_PATH = '/match_transactions/';
export const MATCH_INTERNAL_TRANSACTIONS_PAGE_FULL_PATH = '/match_transactions/:id';
export const AMAZON_SELLER_PAGE_PATH = '/amazon_seller';
export const DASHBOARD_WALKTHROUGH_PATH = '/dashboard_walkthrough';
export const AGREEMENTS_PAGE_PATH = '/agreements';
export const AGREEMENTS_DETAILS_PAGE_PATH = '/agreements/';
export const AGREEMENTS_DETAILS_PAGE_FULL_PATH = '/agreements/:id';
export const AGREEMENT_MATCHED_PAYMENTS_PAGE_FULL_PATH = '/agreements/:id/matched_payments';
export const ADD_AGREEMENT_PATH = '/agreements/add_agreement';
export const ADD_AGREEMENT_FROM_BUSINESS_TO_COMPANY_PATH =
  '/agreements/add_agreement/from_business_to_company';
export const ADD_AGREEMENT_FROM_COMPANY_PATH = '/agreements/add_agreement/from_company';
export const ADD_AGREEMENT_FROM_MEMBER_TO_COMPANY_PATH =
  '/agreements/add_agreement/from_member_to_company';
export const PROJECTS_PAGE_PATH = '/projects';
export const SEE_PROJECT_DETAILS_FULL_PATH = '/see_details/:id';
export const SEE_PROJECTS_DETAILS_PATH = '/see_details/';
export const ADD_INVOICES_TO_PROJECT_PATH = '/add_invoice';
export const ADD_INVOICES_TO_PROJECT_FULL_PATH = '/add_invoice/:id';
export const INVOICE_PARSING_DETAILS_PAGE_PATH = '/invoice_parsing_details';
export const INVOICE_PARSING_DETAILS_PAGE_FULL_PATH = '/invoice_parsing_details/:id';
export const EDIT_INVOICE_PAGE_PATH = '/invoicing/edit';
export const EDIT_INVOICE_PAGE_FULL_PATH = '/invoicing/edit/:id';
export const INVOICING_LIST_PAGE_PATH = '/invoicing_list';
export const TRANSACTIONS_PAGE_PATH = '/transactions';
export const WORKFLOWS_PAGE_PATH = '/workflows';
export const SALES_INVOICE_WORKFLOW_PAGE_PATH = '/workflows/sales_invoice';
export const COMPANION_PAGE_PATH = '/companion';
export const STATEMENTS_PAGE_PATH = '/statements';
export const MARKETPLACE_PAGE_PATH = '/marketplace';
export const ACCOUNTING_REPORTS_DETAILS_PAGE_PATH = '/accounting_reports_details';
export const ACCOUNTING_REPORTS_DETAILS_PAGE_FULL_PATH = '/accounting_reports_details/:id';
export const ADVANCED_SEARCH_SALES_PAGE_PATH = '/advanced_search_sales';
export const ADVANCED_SEARCH_PURCHASES_PAGE_PATH = '/advanced_search_purchases';
export const SUBSCRIPTION_CHANGE_PLAN_UPGRADE_PATH = '/change/plan/upgrade';
export const SECURE_DOWNLOAD_DETAILS_PATH = '/secure_download';
export const SECURE_DOWNLOAD_DETAILS_FULL_PATH = '/secure_download/:token';
export const UPDATE_PASSPORT = '/update/passport';
export const COMPANY_MEMBERS = '/members';
export const PAYMENT_PAGE_PATH = '/payment';
export const MISSING_BANK_PAGE_PATH = '/missing_bank';
export const MISSING_BANK_PAGE_FULL_PATH = '/missing_bank/:id';
export const MISSING_INVOICE_PAGE_PATH = '/missing_invoice';
export const MISSING_INVOICE_PAGE_FULL_PATH = '/missing_invoice/:id';

export const RESTRICTED_MODE_ALLOWED_PATHS = [
  BILLING_SETTINGS_PAGE_PATH,
  ADD_CARD_PAGE_PATH,
  SUPPORT_PAGE_PATH,
  PAYMENT_PAGE_PATH
];
